<template>
  <UiPageTitle title="График платежей" :back-link="{ name: 'payments' }" />
</template>

<script>
import UiPageTitle from '@/components/UiPageTitle.vue'

export default {
  components: { UiPageTitle },
}
</script>
